// extracted by mini-css-extract-plugin
export default {"legend__item":"styles_legend__item__hwB2G","legend__item_text":"styles_legend__item_text__Jf8qP"};